import React from 'react';
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import ReactDataGrid from 'react-data-grid'
import Loading from './Loading';
import Collapsible from './Collapsible';
import Clipboard from 'react-clipboard.js';
import RowRenderer from './RowRenderer';
import RowMenu from './RowMenu'
import Toolbar from './Toolbar'
import Dry from './Dry'
import swal from 'sweetalert'
import { Menu } from "react-data-grid-addons"
import shortid from 'shortid';

import {
  is_logged_on,
  is_validating
 } from "../helpers"
import {
  show_archive_sidebar_feed_actions,
  hide_archive_sidebar_feed_actions,
  show_title_length_column,
  hide_title_length_column,
  feed_entries_index,
  feed_entries_um,
  publish_feed,
  update_xml,
  unpublish_feed,
  restore_feed,
  get_project,
  add_title_columns,
  populate_description,
  set_sorting,
  reset_entry_errors,
  batch_update_entries
} from '../actions'

const { ContextMenuTrigger } = Menu

const mapStateToProps = state => {
  return {
    entries: state.entry,
    threshold: state.preference.preferences.maximum_title_length.value,
    current_filters: state.entry.filters
  };
};

const mapDispatchToProps = dispatch => {
   return {
     populateDescription: (feed_id) =>  dispatch ( populate_description(feed_id) ),
     addTitleColumns: (feed_id) => dispatch ( add_title_columns(feed_id) ),
     showLength: () => dispatch ( show_title_length_column() ),
     hideLength: () => dispatch ( hide_title_length_column() ),
     getProject: (feed_id)  => dispatch ( get_project(feed_id, 1, true, 'minimal') ),
     restoreFeed: (feed_id) => dispatch ( restore_feed(feed_id, 1, 'minimal') ),
     publishFeed: (feed_id) => dispatch ( publish_feed(feed_id, 1, 'minimal') ),
     updateXML: (feed_id)   => dispatch ( update_xml(feed_id, 1, 'minimal') ),
     unpublishFeed: (feed_id) => dispatch ( unpublish_feed(feed_id, 1, 'minimal') ),
     getEntries: (feed_id) => dispatch ( feed_entries_index(feed_id) ),
     getFiltered: (feed_id, filters) => dispatch ( feed_entries_index(feed_id, 1, 50, "", "", filters) ),
     setSorting: (sort, order) => dispatch( set_sorting(sort, order) ),
     getSorted: (feed_id, sort, order, filters) => dispatch ( feed_entries_index(feed_id, 1, 50, sort, order, filters) ),
     getNextEntries: (feed_id, page, per_page, sort, order, filters) => dispatch ( feed_entries_index(feed_id, page, per_page, sort, order, filters) ),
     updateRows: (feed_id, entry_ids, values) => dispatch( feed_entries_um(feed_id, entry_ids, values) ),
     showActions: () => dispatch ( show_archive_sidebar_feed_actions() ),
     hideActions: () => dispatch ( hide_archive_sidebar_feed_actions() ),
     resetErrors: () => dispatch ( reset_entry_errors() ),
     batchUpdate: (feed_id, filters, operations) => dispatch( batch_update_entries(feed_id, filters, operations) )
   }
 }

 class ConnectedEntries extends React.Component {
   constructor () {
     super()
     this.state = {
       calledMoreRowsAtSize: 0,
       maxViewed: 0,
       intervalTimer: false,
       hasActive: false,
       showToolbar: false,
       selectedIndexes: [],
       selectedRows: []
     }
   }

   resetCollapsible() {
     console.log("CLOSING")
     const elem = document.getElementById('collapsible_ul')
     const collapsible = window.M.Collapsible.init(elem);
     collapsible.close()

     this.setState({hasActive: false})
   }

   handleGridRowsUpdated = (e) => {
     // const { action, cellKey, rowIds, fromRow, toRow, updated } = e
     const { action, cellKey, rowIds, updated } = e
     console.log(e)

     if (action === "COLUMN_FILL") {
       return swal({
         title: "Update all items?",
         text: `This action will set the selected cell value to all items that correspond to the selected filtered set.`,
         icon: "warning",
         // buttons: [true, true ],
         buttons: {
           cancel: {
             text: "Cancel",
             value: null,
             visible: true,
             className: "btn red darken-1 waves-effect waves-light",
             closeModal: true,
           },
           confirm: {
             text: "OK",
             value: true,
             visible: true,
             className: "btn red darken-1 waves-effect waves-light",
             closeModal: true
           }
         },
         // dangerMode: true
       }).then(willUpdate => {
         if (willUpdate) {
           // alert("Bang! You are dead!")
           const { current_filters, batchUpdate } = this.props
           const { id } = this.props.match.params

           const operations = [{
             field: cellKey,
             operation: "set",
             value: updated[cellKey]
           }]

           batchUpdate( id, current_filters, operations )

         }
       });
     }

     const { id } = this.props.match.params
     this.props.updateRows( id, rowIds, updated )
     // TODO: dispatch an action to add out of sync icon (no need to fetch)
   };

   componentDidMount() {
     const { id } = this.props.match.params
     this.props.showActions()
     const filters = [{
       field: "sku",
       operator: "!~",
       value: '',
       key: shortid.generate(),
     }]
     this.props.getFiltered( id, filters )
   }

   toggleMore() {
     const elem = document.getElementById('collapsible_ul')
     const collapsible = window.M.Collapsible.init(elem);

     const {hasActive} = this.state
     if (hasActive) {
       collapsible.close()
     } else {
       collapsible.open()
     }
     this.setState({hasActive: !hasActive})
   }

   onRowSelect(rows) {
      // this.setState({selectedRows: rows})
      console.log(rows)
      if (rows.length > 0) {
        this.setState({showToolbar: true})
      } else {
        this.setState({showToolbar: false})
      }
   }
   //
   // logRows(rows) {
   //   console.log(rows)
   //
   // }

   onRowsSelected = rows => {
     const newRows = this.state.selectedRows.concat(rows.map(r => r))
     this.setState({
       selectedIndexes: this.state.selectedIndexes.concat(
         rows.map(r => r.rowIdx)
       ),
       selectedRows: newRows
     });
     this.onRowSelect(newRows)
   };

   onRowsDeselected = rows => {
      let rowIndexes = rows.map(r => r.rowIdx);
      const newRows = this.state.selectedRows.filter( r => rowIndexes.indexOf(r.rowIdx) === -1 )
      this.setState({
        selectedIndexes: this.state.selectedIndexes.filter(
          i => rowIndexes.indexOf(i) === -1
        ),
        selectedRows: newRows
      });
      this.onRowSelect(newRows)
    };


   componentDidUpdate(prevProps, prevState) {

     const {collapsed} = this.props
     const prevCollapsed = prevProps.collapsed

     if (collapsed !== prevCollapsed) {
       return window.dispatchEvent(new Event('resize'));
     }

   }

   componentWillUnmount() {
     this.props.hideActions()
     if ( this.state.intervalTimer !== false ) {
       clearInterval(this.state.intervalTimer)
     }
   }

   addTitleColumns() {
     const { id } = this.props.match.params
     this.setState({hasActive: false})
     this.props.addTitleColumns( id )
   }

   populateDescription() {
     const { id } = this.props.match.params
     this.props.populateDescription( id )
   }

   getFiltered(filters) {
     const { id } = this.props.match.params
     this.props.getFiltered(id, filters)
   }

   handleGridSort = (sortColumn, sortDirection) => {
     let sort, order
     if (sortDirection === "NONE") {
       sort="id"
       order="asc"
     } else {
       sort=sortColumn
       order=sortDirection
     }
     this.setState({calledMoreRowsAtSize: 0, maxViewed: 0})
     const { id } = this.props.match.params
     const { filters } = this.props.entries
     this.props.setSorting(sort, order)
     this.props.getSorted(id, sort, order, filters)
   }

   rowGetter = (i) => {
     const rows = this.props.entries.items
     const rowsCount = rows.length
     const { calledMoreRowsAtSize, maxViewed } = this.state

     if ( i === (rowsCount - 20) && maxViewed > (rowsCount - 20) && calledMoreRowsAtSize !== rowsCount ) {
       const { id } = this.props.match.params
       const {page, total_pages, per_page, total_entries} = this.props.entries.pagination
       const {fetching_page} = this.props.entries
       const upper_limit = Math.min( total_entries, page * per_page )

       if ( total_pages > page && rowsCount <= upper_limit && !fetching_page ) {
         this.setState({calledMoreRowsAtSize: rowsCount})
         const new_page = page + 1
         const {sort, order, filters} = this.props.entries
         this.props.getNextEntries( id, new_page, per_page, sort, order, filters )
       }
     }

     if ( i > maxViewed ) {
      this.setState({ maxViewed: i });
     }

     return this.props.entries.items[i]
   }

   render() {

    const { fetching, fetched, errors } = this.props.entries

    if ( !is_validating() && !is_logged_on() ) {
     return <Redirect to="/" />
    }

    if ( !fetching && !fetched && errors !== undefined && errors !== null && errors.length > 0 ) {
      window.M.toast({
        html: errors
      })
      this.props.resetErrors()
      return <Redirect to="/" />
    }

    const {entries, getProject, updateXML} = this.props
    const {feed_id, items, keys, master_name, feed_name, published, xml_url, xml_pending, xml_status, trash, master_trash, xml_updating, filters, pagination } = entries

    let lengthVisible, title_columns_exist
    if ( keys.constructor === Array && keys.length > 0) {
      lengthVisible = ! keys.find( (e) => e.key === "title_length" ).hidden
      title_columns_exist = keys.filter( (e) => (e.key === "title_1" || e.key === "title_2") ).length > 0
    } else {
      lengthVisible = false
      title_columns_exist = false
    }

    if (fetching) {
     return (
      <Loading />
     )
    }
    let xmlUrl = ''
    let clip='';
    if (published ) {
      xmlUrl = (<div><span className="bold">Optimized Feed Url: </span>{xml_url}</div>)
      if (!xml_pending) {
        clip = (
          <Clipboard data-clipboard-text={xml_url} className="clipboard clip-blue">
          Copy url
          </Clipboard>
        );
      }
    }

    let class1, class2, class3, class4, iconTitle;
    let btnText
    if ( typeof(xml_status) !== "undefined" && xml_status.match(/^outofsync/) ) {
      iconTitle = "XML is out of date"
      if ( xml_updating ) {
        btnText = (xml_pending) ? "...publishing..." : "...updating..."
        iconTitle = "XML is currently updating"
        class4 = (
          <button className="btn waves-effect waves-light"
          disabled="disabled">{ btnText }</button>
        );
      } else if ( xml_pending !== true ) {
        class4 = (
          <button className="btn orange darken-1 waves-effect waves-light"
          onClick={
            () => {
              updateXML(feed_id);
            }
          }>Update XML</button>
        )
      } else {
        class4 = ''
      }
      class3 = <i className="material-icons c-yellow mr-10 flex align-center" title={iconTitle}>error_outline</i>
    } else {
      class3 = ''
      class4 = ''
    }

		if(!trash && published) {

      if ( xml_pending === true || xml_updating === true ) {
        if ( this.state.intervalTimer === false) {
          const timer =  setInterval(function() {
            getProject( feed_id )
          }, 5000)
          this.setState({intervalTimer: timer})
        }
        iconTitle = "In process"
        class1 = <i className="material-icons c-yellow mr-10 flex align-center" title={iconTitle}>access_time</i>;

        if ( ! xml_updating ) {
          btnText = (xml_pending) ? "...publishing..." : "...updating..."

          class2 = (
            <button className="btn waves-effect waves-light"
            disabled="disabled">{ btnText }</button>
          );
        } else {
          class2 = ''
        }
      } else {
        if ( this.state.intervalTimer !== false ) {
          clearInterval(this.state.intervalTimer)
          this.setState({intervalTimer: false})
        }
        iconTitle = "Instance published"
        class1 = <i className="material-icons c-light-green mr-10 flex align-center" title={iconTitle}>cloud_done</i>;
        class2 = (
  				<button className="btn red darken-1 waves-effect waves-light mr-10"
  				onClick={
  					(e) => {
              e.preventDefault()
              const feed_id = this.props.match.params.id;
              this.props.unpublishFeed(feed_id);

  					}
  				}>Unpublish</button>
  			);
      }

		} else if (!trash && !published) {
      iconTitle = "Instance not published"
			class1 = <i className="material-icons c-grey mr-10 flex align-center" title={iconTitle}>cloud_upload</i>;
			class2 = (
				<button className="btn light-green waves-effect waves-light"
				onClick={
					(e) => {
            e.preventDefault()
            const feed_id = this.props.match.params.id;
            this.props.publishFeed(feed_id);

          }
				}>Publish</button>
			);
		} else { //trash
      iconTitle = "Instance is archived"
      class1 = <i className="material-icons c-red flex align-center mr-10" title={iconTitle}>delete</i>;
      if ( ! master_trash ) {
        class2 = (
          <button className="btn red darken-1 waves-effect waves-light" onClick={(e)=>{
            e.preventDefault()
            const feed_id = this.props.match.params.id;
            this.props.restoreFeed(feed_id)

          }}>RESTORE</button>
  			)
      }
    }

    const {toggleMore, addTitleColumns, populateDescription} = this
    const {showLength, hideLength, collapsed, threshold } = this.props
    const {showToolbar} = this.state

    const wrapperClass = collapsed ? "wrapper collapsedWrapper" : "wrapper"


     return (
      <React.Fragment>

        <Dry />

        <div className="collection with-header">

          <div className="collection-header red darken-1 white-text">
            <span className="flow-text">{ master_name }</span> <span className="smallLink"><Link to={`/projects/${this.props.entries.master_id}`}>Go to project overview</Link></span>
          </div>
          <Collapsible
            hasActive = { this.state.hasActive }
            toggleMore = { toggleMore.bind(this) }
            showLength = { showLength }
            hideLength = { hideLength }
            lengthVisible = { lengthVisible }
            addTitleColumns = { addTitleColumns.bind(this) }
            populateDescription = { populateDescription.bind(this) }
            getFiltered = { this.getFiltered.bind(this) }
            resetCollapsible = {this.resetCollapsible.bind(this)}
            title_columns_exist = { title_columns_exist }
            filters = { filters }
            feed_id = { feed_id }
            account_id = {this.props.entries.account_id}
            columns = { keys }
             />

          <div className="collection-header">
            <div className="flex align-center justify-between">
              <div className="flex flex flex-left">
                <div className="mb-10">
                  <h5 className="mr-10">Feed Instance: {feed_name}</h5>
                  { xmlUrl }
                  { clip }
                </div>
              </div>
              <div className="flex flex-right">
                {class1}
                {class3}
                {class2}
                {class4}
              </div>
            </div>

            <div className={ wrapperClass }>
              <ReactDataGrid
                columns={ keys }
                contextMenu={<RowMenu id="row_menu" feed_id={feed_id} />}
                enableCellSelect={true}
                rowSelection={{
                  // enableRowSelect={true}
                  showCheckbox: true,
                  enableShiftSelect: true,
                  onRowsSelected: this.onRowsSelected.bind(this),
                  onRowsDeselected: this.onRowsDeselected.bind(this),
                  selectBy: {
                    indexes: this.state.selectedIndexes
                  }
                  // onRowSelect={this.logRows.bind(this)}
                }}
                headerRowHeight={50}
                minColumnWidth={100}
                minHeight={window.innerHeight - 270}
                onGridRowsUpdated={this.handleGridRowsUpdated}
                onGridSort={this.handleGridSort}
                rowGetter={this.rowGetter}
                rowHeight={100}
                rowRenderer={ <RowRenderer threshold={threshold} /> }
                rowsCount={items.length}
                toolbar={
                  <Toolbar
                    visible={showToolbar}
                    fetchedRows={items.length}
                    totalRows={pagination.total_entries}
                    selectedRows={this.state.selectedRows.map( r => r.row )}
                    feed_id={feed_id}
                  />
                }
                RowsContainer={ContextMenuTrigger}
              />
            </div>
          </div>
        </div>
       </React.Fragment>
     )
   }

 }

 const Entries = connect(mapStateToProps, mapDispatchToProps)(ConnectedEntries);

 export default Entries;



// WEBPACK FOOTER //
// ./src/js/components/Entries.js